import React from 'react';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-spinner">🦊</div>
        <h2>Загружаем NeuroFox...</h2>
        <p>Подготавливаем ваш персональный ассистент</p>
      </div>
    </div>
  );
};
